import { remove } from 'diacritics'

/**
 * Lowercases or uppercases the given input, removes diacritcs
 */
export const normalize = (str: string, mode: 'toLowerCase' | 'toUpperCase' = 'toLowerCase'): string => remove(str[mode]())
